import React from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { database } from "../app-database";
import { goTo } from "../tools";
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';
import StepperPaso3 from '../stepper-gnp-registro/stepper-paso3.cmpt';
import StepperResposnsivo3 from '../stepper-gnp-registro/stepper-responsivo3.cmpt';
import FormularioSeguridad from "./formulario-seguridad.cmpt";

const mapState = (state) => {
	return {
		dispositivo: state.global.dispositivo,
		preguntas1: state.catalogos.catalogoPregunta1,
		preguntas2: state.catalogos.catalogoPregunta2
	};
};

const mapDispatch = (dispatch) => {
	return {
		regresar: (disp) => {
			dispatch({ "type": "EVENT_REGISTRO_DP-REGRESAR", "dispositivo": disp });
			dispatch({ "type": "REGISTRO_PASO", "paso": 1 });
		},
		avisoPrivacidad: (showAviso) => {
			dispatch({ "type": "AVISO_PRIVACIDAD", "showAviso": showAviso });
		},
		llenarPreguntas: (cat1, cat2) => {
			dispatch({ "type": "CARGAR_CATALOGO_PREGUNTAS", catalogoPregunta1: cat1, catalogoPregunta2: cat2 });
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

const validate = values => {
	console.log(values, Object.keys(values).length);
};

class SeguridadForm extends React.Component {
	claseCaracteresCompletos = "";
	state = {
		showValidatorPass: false,
		caracteresCompletos: 'vacio',
		caracterMayuscula: 'vacio',
		caracterGNP: 'vacio',
		caracterConsecutivoIgual: 'vacio',
		caracterConsecutivo: 'vacio',
		espacioEnBlanco: 'vacio',
		caracteresAlfabeticos: 'vacio',
		caracteresNumericos: 'vacio',
		caracterEspecial: 'vacio',
		contraExitosa: false,
		btnHabilitado: 'deshabilita',
		showPass: true,
		showConfPass: true,
		showResp1: true,
		showResp2: true,
		password: "",
		confPassword: "",
		respuesta1: "",
		respuesta2: "",
		loadingPequeno: false,
		pregunta1: 0,
		pregunta2: 0,
		validate: {
			password: false,
			confPassword: false,
			respuesta1: false,
			respuesta2: false,
		},
		showTooltip: false,
		mensaje: "",
		type: "",
		titulo: ""
	}

	componentWillMount = () => {
		database.ref("preguntas").on("value", snapshot => {
			const data = snapshot.val();
			this.props.llenarPreguntas(data.pregunta1, data.pregunta2);
		});
	}

	handleChange = (sParam, e) => {
		this.setState({ [sParam]: e.target.value });
		this.validate(sParam, e.target.value);
	}

	muestraTooltip = (show, type?, titulo?, mensaje?) => {
		setTimeout(() => {
			this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
		}, 300);
		console.log(this.props);
	}

	cierraTooltip = e => {
		this.setState({
			showTooltip: !this.state.showTooltip
		});
	}

	toggle = (sParam) => {
		this.setState({ [sParam]: !this.state[sParam] });
	}

	handleSelect = (sParam, e) => {
		this.setState({ [sParam]: e });
	}

	componentDidMount = () => {
		$(".pass, .confpass").bind("copy paste", function (e) {
			e.preventDefault();
			return false;
		});
		const url = window.location.hash;
		var main = document.getElementsByClassName("main")[0];
		if (url.includes("#!/gnp/registro-seguridad")) {
			main.style.maxHeight = "100%";
			main.style.paddingBottom = "30px";
			main.style.overflow = "hidden auto";
		}
	}

	regresar = () => {
		console.log(this.props.dispositivo);
		this.props.avisoPrivacidad(true);
		this.props.regresar(this.props.dispositivo);
		this.props.tagManager({ "type": "REGISTRO_POLIZA_REGRESAR_SEGURIDAD", "dispositivo": this.props.dispositivo });
		goTo("gnp/registro");
	}

	expandir = () => {
		var mostrarstep = document.getElementById("steppervertical");
		if (mostrarstep.style.display === "block") {
			mostrarstep.style.display = "none";
		} else {
			mostrarstep.style.display = "block";
		}
	}

	render() {
		const { handleSubmit } = this.props;
		return (
			<form onSubmit={handleSubmit}>
				<ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
					show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
				</ModalSintillo>

				<div className="flex layout-gt-md-row layout-md-row layout-xs-column layout-sm-column layout-align-center-center">
					<StepperPaso3></StepperPaso3>

					<div id="stepperesponsivo">
						<span id="registropaso3"></span>
						<label id="registroletra1">SEGURIDAD</label>
						<span id="expancion" onClick={this.expandir}></span>
						<div style={{ maxWidth: 380, maxHeight: 400, margin: 'auto' }} id="steppervertical">
							<StepperResposnsivo3></StepperResposnsivo3>
						</div>
					</div>
				</div> 

				<div id="div-gral-return" style={{marginLeft:'0'}}>
					<div className="div-return">
						<div  style={{textAlign:'center', width:'100%'}}>
							<label className="txt-1">Ingresa la información solicitada</label>
						</div>
					</div>
				</div>
				<FormularioSeguridad></FormularioSeguridad>
			</form>
		);
	}
}

SeguridadForm = reduxForm({
	form: "datosSeguridad",
	validate
})(SeguridadForm);

export default connect(mapState, mapDispatch)(SeguridadForm);


// WEBPACK FOOTER //
// ./src/gnp-registro-seguridad/seguridad.frm.js